import {pagination} from "../../app/services/dataTemplates"
import {auth, post, url} from "../../app/services/Backend/HttpRequest"

export default {
  namespaced: true,
  state(){
    return {
      loaded: false,
      collection: [],
      pagination: Object.assign({}, pagination),
    }
  },
  mutations: {
    truncate(state) {
      state.loaded = false

      state.collection = []

      state.pagination = Object.assign({}, pagination)
    },

    fill(state, payload) {
      state.collection = state.collection.concat(payload.data)

      state.pagination = payload.pagination

      state.loaded = true
    },
  },
  actions: {
    fetch({rootState, commit}, payload){

      const input = {
        url: url('auth/search/get'),
        payload,
        headers: auth(rootState)
      }

      return post(input).then(response => commit('fill', response.data))
    },
  },
}



// WEBPACK FOOTER //
// ./resources/assets/js/store/modules/searches.js